export default __webpack_public_path__ + "static/media/General's Belt of the Battlements.61bbed29.jpg";